import { createFileRoute, redirect } from "@tanstack/react-router"
import { z } from "zod/v4"

import { MagicLinkSent } from "#pages/login/magic-link-sent.tsx"

const searchSchema = z.object({
  email: z.string().optional(),
  redirect: z.string().optional(),
})

export const Route = createFileRoute("/_auth/magic-link-sent")({
  validateSearch: searchSchema,
  beforeLoad: ({ context, search }) => {
    if (context.auth.isAuthenticated) {
      throw redirect({ to: search.redirect ?? "/" })
    }
  },
  component: MagicLinkSentPage,
})

function MagicLinkSentPage() {
  const { email } = Route.useSearch()
  return <MagicLinkSent email={email} />
}
